import {clientFetchData} from './clientData'
import {fileFetchData, fileTypeFetchData, fileMetaDataCategoryFetchData, fileMetaDataValueFetchData, fileMetaDataValueWithCategoryFetchData} from './fileData'
import {fetchFrontEndUser} from './frontEndUser'

import { getAllFiles }  from './file';
import { getAllProducts } from './product';
import { getAllReportTypes } from './report';
import firebase from '../components/Firebase'
export const megaDispatch = (url) =>
{

	return (dispatch) => {


		dispatch(clientFetchData(url + '/api/clients/action/getclients'));

	    // -- get file metadata categorie data
	    //dispatch(fileMetaDataCategoryFetchData(url + '/api/files/action/getFileMetaDataCategories'))

	    // -- get file categories
	   // dispatch(fileTypeFetchData(url + '/api/files/action/getFileTypes'))

	     // -- get file categories
	    //dispatch(fileMetaDataValueFetchData(url + '/api/files/action/getFileMetaDataValue'))

	    //-- get file meta data value with categories
	    //dispatch(fileMetaDataValueWithCategoryFetchData(url + '/api/files/action/getMetaValuesByCategory'));

	    // -- get front end users
	    dispatch(fetchFrontEndUser(url + '/api/frontenduser/action/getUsers'))

	     // -- Get all files
        dispatch(getAllFiles(url));

        // -- Get all report types
        //dispatch(getAllReportTypes(url + '/api/report/action/getReports'));


        // -- Get all products
        //dispatch(getAllProducts(url));

	}
}



// WEBPACK FOOTER //
// ./src/actions/megaDispatch.js